// extracted by mini-css-extract-plugin
export default {"statusTypeLabel":"ButtonReSendEmail_statusTypeLabel__fqEid","icon":"ButtonReSendEmail_icon__8AeYt","black":"ButtonReSendEmail_black__iqQHM","red":"ButtonReSendEmail_red__EJ2jL"};